const crypto = require('crypto');

export const LD_ANONYMOUS_USER_KEY = '2f183a4e64493af3f377f745eda502363cd3e7ef6e4d266d444758de0a85fcc8-ANONYMOUS';

export const getUniqueUserKey = (locale = 'en-US') => {
  try {
    const idHasher = crypto.createHash('sha256');
    idHasher.update(locale);
    return idHasher.digest('hex');
  } catch (_) {
    return LD_ANONYMOUS_USER_KEY;
  }
};

export default {
  getUniqueUserKey,
};
